import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import Link from 'components/common/Link';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

const styles = theme => ({
  grid: {
    marginTop: 15,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

const SignUpPhoneChangeForm = ({ className, handleSubmit, error, classes }) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    {error &&
      <Grid
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Phone Number"
          name="Phone Number"
          label="Mobile Phone Number"
          component={TextField}
          validate={[validate.required, validate.phone]}
          format={value => (value ? value.replace('+1 ', '') : '')}
          normalize={normalize.phone}
          maxLength="14"
          startAdornment={
            <InputAdornment position="start">
              <TextFieldAdornmentText>
                +1
              </TextFieldAdornmentText>
            </InputAdornment>
          }
          size="lg"
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

SignUpPhoneChangeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

SignUpPhoneChangeForm.defaultProps = {
  error: null,
  className: '',
};

export default reduxForm()(withStyles(styles)(SignUpPhoneChangeForm));



// WEBPACK FOOTER //
// ./src/components/account/SignUpPhoneConfirm/SignUpPhoneChangeForm.js